import { auth$, redirectToSSO, signInBySSO } from '@creditsights/api-ui-web';
import { useEffect, useState } from 'react';
import { QueryClient } from 'react-query';

interface UseIsAuthenticatedResult {
  isAuthenticated: boolean;
  setIsAuthenticated: (value: boolean) => void;
}

// Implemented it here because we need to check it just once
const url = new URL(window.location.href);
const ssoId = url.searchParams.get('ssoid');
const ssoSuccess = url.searchParams.get('sso_success') === 'true';
url.searchParams.delete('ssoid');
url.searchParams.delete('sso_success');
window.history.pushState(undefined, '', url);

let isSSOChecked = false;
let signInBySSOPromise = Promise.resolve();

const useIsAuthenticated = (queryClient: QueryClient): UseIsAuthenticatedResult => {
  const isAuthenticatedRaw = !!auth$.value;

  // We have to set it "true" if SSO flow should be involved, because in some MFs we are redirecting user to login page if one isn't logged in
  const [isAuthenticated, setIsAuthenticated] = useState(isAuthenticatedRaw || ssoSuccess || !!ssoId);

  if (!isSSOChecked) {
    isSSOChecked = true;

    if (!isAuthenticatedRaw) {
      if (ssoSuccess) {
        signInBySSOPromise = signInBySSO();
      } else if (ssoId) {
        redirectToSSO(ssoId, url.toString());
        // If user should be redirected to SSO provider, we have to do nothing
        signInBySSOPromise = new Promise(() => {});
      }
    }
  }

  useEffect(() => {
    // We have to wait for signInBySSO
    signInBySSOPromise.finally(() => {
      auth$.subscribe((token) => {
        // clears all existing cache if user logs out
        if (!token) {
          queryClient.clear();
        }
        setIsAuthenticated(!!token);
      });
    });
  }, []);

  return {
    isAuthenticated,
    setIsAuthenticated,
  };
};

export default useIsAuthenticated;
